export function sectionId(title) {
  return "sec-" + String(title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}

export function Section({ icon: Icon, title, children }) {
  return (
    <section id={sectionId(title)} className="scroll-mt-24 border border-zinc-200 bg-white transition-shadow duration-300">
      <div className="flex items-center gap-2 border-b border-zinc-200 bg-zinc-50 px-5 py-3 text-xs font-bold uppercase tracking-[0.2em] text-zinc-600">
        <Icon size={15} /> {title}
      </div>
      <div className="p-5">{children}</div>
    </section>
  );
}
